import { useState, useEffect } from "react";
import Recommendation from "./Recommendation";
import SearchItem from "./SearchItem";
import { BeatLoader } from "react-spinners";

export default function Search(props) {
    const [movies, setMovies] = useState([]);

    useEffect(() => {
        if (!props.movieName || props.movieName.length < 2) {
            setMovies([]);
            return;
        }

        const fetchData = async (movieName) => {
            try {
                const response = await fetch(`https://likethismovie-com.onrender.com/movies/search/` + encodeURIComponent(movieName));
                
                if (!response.ok) {
                    throw new Error("API isteği başarısız oldu");
                }
                
                const data = await response.json();
                console.log(data.results);
                setMovies(data.results || []); 
            } catch (error) {
                console.error("Film arama hatası:", error);
                setMovies([]);
            }
        };

        const handler = setTimeout(() => {
            fetchData(props.movieName);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
        
    }, [props.movieName]); 

    return (
        <div className="recent-searches pt-3">
            {
                movies.length > 0 ? (
                    movies.map((movie) => 
                        <SearchItem 
                            onClick={() => 
                                {
                                    props.setSelectedMovie(movie.original_title); 
                                    props.setRecommendationComponent(<Recommendation setIsLoading={props.setIsLoading} movieId={movie.id} />);
                                }}
                            key={movie.id} 
                            name={movie.original_title} 
                            image={movie.poster_path ? `https://image.tmdb.org/t/p/w200${movie.poster_path}` : 'https://via.placeholder.com/100x150?text=No+Image'}
                            releaseYear={movie.release_date ? movie.release_date.substring(0, 4) : 'N/A'} 
                        />
                    )
                ) : (
                    props.movieName && props.movieName.length > 0 && <p>Loading...</p>
                )
            }
            
        </div>
    )
}